import { render, staticRenderFns } from "./endemicPlantInfo.vue?vue&type=template&id=19e9617c&scoped=true&"
import script from "./endemicPlantInfo.vue?vue&type=script&lang=js&"
export * from "./endemicPlantInfo.vue?vue&type=script&lang=js&"
import style0 from "./endemicPlantInfo.vue?vue&type=style&index=0&id=19e9617c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e9617c",
  null
  
)

export default component.exports